import React from "react";

function SMSList() {
    return <div>SMSList</div>;
}

export default SMSList;
